<template>
    <div style="">
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a href="/event/list">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>イベント管理</b>
                            </div>
                        </div>
                        <div class="col-4 text-end">
                            <div style="display: inline-flex;">
                                <a class="text-center" href="/event/entry/question1" style="text-decoration:none;">
                                    <div class="text-center" style="color:#cdcdcd;padding-top:7px;">
                                        <svg style="height:20px;width:20px;fill:#cdcdcd;">
                                            <use xlink:href="/images/Plus.svg#plus"></use>
                                        </svg>
                                        <div class="text-nowrap" style="font-size: 8px;">
                                            作成・管理
                                        </div>
                                    </div>
                                </a>
                                <div style="width:15px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" style="height: 100%;" v-if="is_page_init">
                <div class="row" style="height: 100%">
                    <div class="col" style="height: 100%">
                        <div class="text-center" style="height: 100%">
                            <div class="spinner-grow" style="margin-top:300px;color:#fff;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap" v-else>
                <div class="container" style="margin-top:60px;">
                    <div class="row" style="">
                        <div class="col" v-if="count == 0">
                            <div class="text-center" style="padding:20px 0;font-size:18px;color:#6B4EFF">
                                まだ作成されていません
                            </div>
                            <div>
                                <img src="/images/event_admin_entry.webp"
                                    style="width:100%;height:auto;border-radius: 33px;">
                                <div style="margin-top: -100px">
                                    <div class="row justify-content-center">
                                        <div class="col-8">
                                            <div class="d-grid gap-2">
                                                <a type="button" class="btn btn-skip" href="/event/entry/question1"
                                                    style="padding:12px 0;border-radius: 50px;">
                                                    新規イベント作成
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col px-0" v-else>
                            <div v-for="event in events" :key="event.id">
                                <div style="background-color:#fff;">
                                    <div>
                                        <div class="text-center footer_event_befor_box" v-if="event.is_open == false">
                                            <div class="row mx-0">
                                                <div class="col text-start">
                                                    非公開
                                                </div>
                                                <div class="col text-end">
                                                    - / {{ event.member_count }}人
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center footer_event_after_box"
                                            v-else-if="isEventEnd(event.event_at_to)">
                                            開催終了
                                        </div>
                                        <div class="text-center footer_event_befor_box" v-else-if="event.is_preparation">
                                            <div class="row mx-0">
                                                <div class="col text-start">
                                                    受付準備中で公開
                                                </div>
                                                <div class="col text-end">
                                                    {{ event.member_count_total }} / {{ event.member_count }}人
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center footer_event_now_box" v-else-if="event.is_recruiting">
                                            <div class="row mx-0">
                                                <div class="col text-start">
                                                    募集中で公開
                                                </div>
                                                <div class="col text-end">
                                                    {{ event.member_count_total }} / {{ event.member_count }}人
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center footer_event_befor_box" v-else>
                                            <div class="row mx-0">
                                                <div class="col text-start">
                                                    申込締切で公開
                                                </div>
                                                <div class="col text-end">
                                                    {{ event.member_count_total }} / {{ event.member_count }}人
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding-top:15px;padding-bottom:15px;">
                                        <div class="row mx-0">
                                            <div class="col-1"></div>
                                            <div class="col-3 text-center">
                                                <img :src="event.img_url + im" style="width: 100%; height:auto;">
                                            </div>
                                            <div class="col">
                                                <h5 style="color:#000">{{ event.thumbnail }}</h5>

                                                <div style="display:flex">
                                                    <div style="padding-right:5px">
                                                        <i class="bi bi-clock"
                                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                    </div>
                                                    <div>
                                                        <div v-if="event.event_type == 1">
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                1部　{{ setDaysWithSlash(event.event_at_from_1) }}{{
                                                                    setRmDate(event.event_at_from_text_1) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                2部　{{ setDaysWithSlash(event.event_at_from_2) }}{{
                                                                    setRmDate(event.event_at_from_text_2) }}</div>
                                                        </div>
                                                        <div v-if="event.event_type == 2">
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                1部　{{ setDaysWithSlash(event.event_at_from_1) }}{{
                                                                    setRmDate(event.event_at_from_text_1) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                2部　{{ setDaysWithSlash(event.event_at_from_2) }}{{
                                                                    setRmDate(event.event_at_from_text_2) }}</div>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                3部　{{ setDaysWithSlash(event.event_at_from_3) }}{{
                                                                    setRmDate(event.event_at_from_text_3) }}</div>
                                                        </div>
                                                        <div v-else>
                                                            <div class=""
                                                                style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                {{ setDaysWithSlash(event.event_at_from) }}{{
                                                                    setRmDate(event.event_at_from_text) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="display:flex">
                                                    <div style="padding-right:5px">
                                                        <i class="bi bi-geo-alt"
                                                            style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                    </div>
                                                    <div>
                                                        <div class="" style="color:#777;font-size:14px;padding-bottm:5px;">
                                                            {{ event.address_view }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1"></div>
                                        </div>
                                        <div class="row mx-0">
                                            <div class="col-1"></div>
                                            <div class="col" style="border-bottom: 1px dotted #999;"></div>
                                            <div class="col-1"></div>
                                        </div>
                                        <div v-if="event.event_type == 1">
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">1部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_2 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_4) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_3) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">2部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_3 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_6) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_5) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">通し
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_5 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_10) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_9) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                        </div>
                                        <div v-else-if="event.event_type == 2">
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">1部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_2 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_4) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_3) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">2部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_3 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_6) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_5) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">3部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_4 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_8) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_7) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">通し
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_5 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_10) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_9) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col-2" style="padding:10px 0;color:#6B4EFF;font-size:11px">1部
                                                </div>
                                                <div class="col"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    当日決済&nbsp;{{ event.member_count_1 }}人
                                                </div>
                                                <div class="col text-end"
                                                    style="padding:10px 0;border-bottom: 1px dotted #999;font-size:11px">
                                                    男性&nbsp;¥{{ Number(event.member_amount_2) | priceLocaleString }}<br>
                                                    女性&nbsp;¥{{ Number(event.member_amount_1) | priceLocaleString }}
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="row mx-0">
                                                <div class="col-1"></div>
                                                <div class="col text-end" style="padding:10px 0;">
                                                    <b>売上金額&nbsp;¥{{ Number(event.member_amount_1) +
                                                        Number(event.member_amount_2) +
                                                        Number(event.member_amount_3) + Number(event.member_amount_4) +
                                                        Number(event.member_amount_5) +
                                                        Number(event.member_amount_6) + Number(event.member_amount_7) +
                                                        Number(event.member_amount_8) +
                                                        Number(event.member_amount_9) + Number(event.member_amount_10) |
                                                        priceLocaleString }}</b>
                                                </div>
                                                <div class="col-1"></div>
                                            </div>
                                        </div>
                                        <div class="row mx-0">
                                            <div class="col-1"></div>
                                            <div class="col" style="border-bottom: 1px dotted #999;"></div>
                                            <div class="col-1"></div>
                                        </div>
                                        <br>
                                        <div class="row mx-0">
                                            <div class="col-1"></div>
                                            <div class="col-2 text-start">
                                                <div class="">
                                                    <div class="dropdown">

                                                        <a href="#" role="button" :id="'menu' + event.id"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i class="bi bi-three-dots"></i>
                                                        </a>

                                                        <ul class="dropdown-menu" :aria-labelledby="'menu' + event.id"
                                                            style="padding:10px;background:#fff;box-shadow: 1px 1px 5px 2px rgba(119, 119, 119, 0.6);font-size: 14px;border-radius: 5px;">
                                                            <li style="padding:5px;font-size:14px;"><a style="color:#999"
                                                                    :href="'/event/admin/mail/add/' + event.id">管理者権限を共有</a>
                                                            </li>
                                                            <li style="padding:5px;font-size:14px;"> <a style="color:#999"
                                                                    :href="'/event/admin/mail/list/' + event.id">管理者一覧</a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col text-end">
                                                <a type="button" class="btn btn-luna-outline"
                                                    :href="'/event/admin/member/list/' + event.id"
                                                    style="padding:8px 12px;border-radius: 10px;font-size:14px">
                                                    参加者リスト
                                                </a>
                                                <a type="button" class="btn btn-luna-outline"
                                                    :href="'/event/admin/mod/' + event.id"
                                                    style="padding:8px 12px;border-radius: 10px;font-size:14px">
                                                    編集する
                                                </a>
                                            </div>
                                            <div class="col-1"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Footer from './../Footer.vue'
export default {
    data() {
        return {
            events: [],
            count: 0,
            is_page_init: true,
            im: '',
        };
    },
    methods: {
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchEventAdmin()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchEventAdmin() {
            await axios.get("/api/event/admin/list")
                .then(
                    (response) => {
                        this.events = response.data.events
                        this.count = response.data.count
                        this.is_page_init = false
                        this.im = '?' + response.data.im
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("管理者の取得に失敗しました")
                    }
                })
        },
        isEventEnd(event) {
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            return (eDate < today);
        },
        setDaysWithSlash(event) {
            let event_date = event.split(' ')[0]
            return Number(event_date.split('-')[1]) + '/' + Number(event_date.split('-')[2])
        },
        setRmDate(event) {
            return event.substr(10) + '〜';
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
            }
        }
        else {
            this.isAuth()
        }
    },
    filters: {
        priceLocaleString(value) {
            if (value != undefined) {
                return value.toLocaleString();
            } else {
                return value;
            }
        },
    },
}
</script>
<style scoped>
.footer_event_after_box {
    background-color: #cdcdcd;
    color: #999;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_befor_box {
    background-color: #C6C4FF;
    color: #6B4EFF;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_now_box {
    background-color: #6B4EFF;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
